import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { PACKAGE_SESSION_SHOW } from '~/endpoints';
import { PackageSessionResponseSchema } from '~/validation/api/packageSessionResponse';
import { handleErrorResponse } from '~/helpers/api';

type Request = {
  sessionId: string;
  locale: string;
};

export const getPackageSession = async (request: Request) => {
  const api = PACKAGE_SESSION_SHOW.replace(':sessionId', request.sessionId);

  try {
    const response = await axios.get(api, {
      headers: {
        'X-Locale': request.locale,
      },
    });

    const json = response.data;

    return PackageSessionResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function usePackageSession(request: Request) {
  return useQuery({
    queryKey: [
      'packageSession',
      request.sessionId,
      request.locale,
    ],
    queryFn: () => getPackageSession(request),
    staleTime: 2, // 2 seconds
    retry: false,
    enabled: !!request.sessionId,
  });
}
